import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseComponent } from '../../../core/layout/components/abstracts/base.component';
import { IPagination } from '../../../core/interfaces/IPagination';

@Component({
  selector: 'app-pagination',
  standalone: true,
  imports: [],
  templateUrl: './pagination.component.html',
  styleUrl: './pagination.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaginationComponent extends BaseComponent {

  @Input() isDisabled = false;
  @Input() set pagination(pagination: IPagination) {
    this._pagination = pagination;

    if (this._pagination) {
      this.calculate(false);
    }
  };

  @Output() pageChange = new EventEmitter<number>();

  public maxPage: number;
  public from: number;
  public to: number;
  public totalPages: number[];
  public paginationState: 'at-first' | 'in-middle' | 'at-end';

  private _pagination: IPagination;

  public get pagination(): IPagination {
    return this._pagination;
  }

  public loadPage(page: number): void {
    this.pagination.page = page;

    this.pageChange.emit(this.pagination.page);
    this.calculate();
  }

  private calculate(propagateChanges = true): void {
    const { totalResults, results, page } = this.pagination;
    this.maxPage = Math.ceil(totalResults / results);
    this.to = page * results;
    this.from = this.to - results + 1;
    this.totalPages = [].generateArrayByLength(this.maxPage);

    if (innerWidth > 480) {
      if (this.maxPage > 5) {

        if (page < 5) {
          this.paginationState = 'at-first';
        }

        if (page >= 5) {
          this.paginationState = 'in-middle';
        }

        if (page >= this.maxPage - 3) {
          this.paginationState = 'at-end';
        }
      }
    } else {
      if (this.maxPage > 5) {

        if (page < 3) {
          this.paginationState = 'at-first';
        }

        if (page >= 3) {
          this.paginationState = 'in-middle';
        }

        if (page > this.maxPage - 2) {
          this.paginationState = 'at-end';
        }
      }
    }

    if (propagateChanges) {
      if (page > this.maxPage) {
        this.pagination.page = this.maxPage;
        this.pageChange.emit(this.pagination.page);
      }

      if (page < 1) {
        this.pagination.page = 1;
        this.pageChange.emit(this.pagination.page);
      }
    }
  }
}
